"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  AbTestingAward: ['ab-testing-award', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.75,15.75V23.5a.25.25,0,0,0,.25.25h7.5a.25.25,0,0,0,.25-.25V15.75a1,1,0,0,0-1-1h-6A1,1,0,0,0,10.75,15.75Zm3,2.75a.75.75,0,0,1,0-1.5h.5a1.252,1.252,0,0,1,1.25,1.25v2.5a.25.25,0,0,0,.25.25.75.75,0,0,1,0,1.5h-2a.75.75,0,0,1,0-1.5.25.25,0,0,0,.25-.25v-2A.25.25,0,0,0,13.75,18.5Z', 'M20.5,23.75h3a.25.25,0,0,0,.25-.25V20.75a1,1,0,0,0-1-1H20.5a.25.25,0,0,0-.25.25v3.5A.25.25,0,0,0,20.5,23.75Z', 'M6,23.75H9a.25.25,0,0,0,.25-.25V20A.25.25,0,0,0,9,19.75H6.75a1,1,0,0,0-1,1V23.5A.25.25,0,0,0,6,23.75Z', 'M17.722,9.133a.5.5,0,0,0-.325-.88H15.739a.249.249,0,0,1-.235-.167l-.533-1.5a.5.5,0,0,0-.942,0l-.532,1.5a.251.251,0,0,1-.236.167H11.6a.5.5,0,0,0-.325.88L12.524,10.2a.25.25,0,0,1,.07.281l-.742,1.9a.5.5,0,0,0,.724.61L14.37,11.9a.253.253,0,0,1,.26,0l1.794,1.088a.5.5,0,0,0,.724-.61l-.742-1.9a.25.25,0,0,1,.07-.281Z', 'M20.75,13.75a1,1,0,0,0,1-1V3.25a3,3,0,0,0-3-3H3.25a3,3,0,0,0-3,3v11a3,3,0,0,0,3,3h4.5a1,1,0,0,0,0-2H3.25a1,1,0,0,1-1-1V5.5a.25.25,0,0,1,.25-.25h17a.25.25,0,0,1,.25.25v7.25A1,1,0,0,0,20.75,13.75ZM4,3.75A.75.75,0,1,1,4.75,3,.749.749,0,0,1,4,3.75Zm2.5,0A.75.75,0,1,1,7.25,3,.749.749,0,0,1,6.5,3.75Zm2.5,0A.75.75,0,1,1,9.75,3,.749.749,0,0,1,9,3.75Z']],
  AbTestingMonitors: ['ab-testing-monitors', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M7.87,3.254a.73.73,0,0,0-.729.729v.479a.25.25,0,0,0,.25.25h.958a.25.25,0,0,0,.25-.25V3.983A.73.73,0,0,0,7.87,3.254Z', 'M12.243.1H3.011A1.946,1.946,0,0,0,1.067,2.04V9.814a1.945,1.945,0,0,0,1.944,1.943H6.648a.25.25,0,0,1,.25.25v.958a.25.25,0,0,1-.25.25H3.983a.972.972,0,1,0,0,1.944H7.87a.972.972,0,0,0,.972-.972v-2.43a2.826,2.826,0,0,1,2.794-2.915h2.786a.25.25,0,0,0,.25-.25V2.04C14.672.872,13.21.1,12.243.1Zm-2.187,8.26a.729.729,0,1,1-1.457,0V6.419a.25.25,0,0,0-.25-.25H7.391a.25.25,0,0,0-.25.25V8.356a.729.729,0,1,1-1.458,0V3.983a2.187,2.187,0,1,1,4.373,0Z', 'M16.616,12.972h-.479a.25.25,0,0,0-.25.25v.958a.251.251,0,0,0,.25.25h.479a.729.729,0,1,0,0-1.458Z', 'M16.616,15.888h-.479a.25.25,0,0,0-.25.25V17.1a.25.25,0,0,0,.25.25h.479a.729.729,0,1,0,0-1.457Z', 'M18.074,20.268a.249.249,0,0,1,.25-.25h2.787c.8,0,1.822-.653,1.822-1.458v-6.8c0-.8-1.139-1.457-1.944-1.457H11.636A1.359,1.359,0,0,0,10.3,11.757v6.8a1.458,1.458,0,0,0,1.458,1.458H15.88a.249.249,0,0,1,.25.25v1.443a.25.25,0,0,1-.25.25H12.729a.972.972,0,1,0,0,1.944h8.746a.972.972,0,1,0,0-1.944H18.324a.25.25,0,0,1-.25-.25ZM16.616,18.8H15.158a.729.729,0,0,1-.729-.729V12.243a.729.729,0,0,1,.729-.728h1.458A2.188,2.188,0,0,1,18.8,13.7a2.165,2.165,0,0,1-.533,1.417.062.062,0,0,0,0,.081,2.167,2.167,0,0,1,.533,1.417A2.189,2.189,0,0,1,16.616,18.8Z']],
  AbTestingChemistry: ['ab-testing-chemistry', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.473,12.791V21.2a3.162,3.162,0,0,0,.982,2.266A1.8,1.8,0,0,0,21.718,24h.009a1.7,1.7,0,0,0,1.211-.5,3.242,3.242,0,0,0,1.019-2.324V12.791a.747.747,0,0,0-.747-.748H20.221A.748.748,0,0,0,19.473,12.791Zm1.5,1a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25v3.236a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25Z', 'M8.914,22.16A1.245,1.245,0,0,0,10.007,24h6.975a1.246,1.246,0,0,0,1.1-1.829l0,0-2.318-4.54a.244.244,0,0,1-.027-.113V14.285A1.247,1.247,0,0,0,14.49,13.04H12.5a1.246,1.246,0,0,0-1.245,1.245v3.223a.253.253,0,0,1-.028.114L8.917,22.153ZM12.246,18.9l.309-.608.01-.017a1.24,1.24,0,0,0,.181-.648V14.784a.25.25,0,0,1,.25-.25h.995a.25.25,0,0,1,.25.25v2.847a1.186,1.186,0,0,0,.15.593l.011.019.337.661a.247.247,0,0,1-.01.244.25.25,0,0,1-.213.12H12.469a.253.253,0,0,1-.214-.12A.25.25,0,0,1,12.246,18.9Z', 'M.043,14.534a2.993,2.993,0,0,0,2.989,2.99H9.011a1,1,0,0,0,0-1.993H3.032a1,1,0,0,1-1-1V5.318a.25.25,0,0,1,.25-.25H19.721a.249.249,0,0,1,.25.25V9.552a1,1,0,1,0,1.993,0V2.99A2.992,2.992,0,0,0,18.975,0H3.032A2.993,2.993,0,0,0,.043,2.99ZM8.762,1.993a.748.748,0,1,1-.748.748A.747.747,0,0,1,8.762,1.993Zm-2.491,0a.748.748,0,1,1-.748.748A.747.747,0,0,1,6.271,1.993Zm-2.491,0a.748.748,0,1,1-.748.748A.747.747,0,0,1,3.78,1.993Z', 'M11,11.212a.5.5,0,0,0-.429-.493l-.263-.037h0A1.5,1.5,0,0,1,9.044,9.413l-.038-.264a.5.5,0,0,0-.987,0l-.038.265a1.5,1.5,0,0,1-1.267,1.268h0l-.263.037a.5.5,0,0,0,0,.987l.264.038a1.5,1.5,0,0,1,1.268,1.269l.038.264a.5.5,0,0,0,.987,0l.038-.265a1.5,1.5,0,0,1,1.268-1.268h0l.263-.038A.5.5,0,0,0,11,11.212Z', 'M18.643,8.889a.5.5,0,0,0-.427-.494l-.266-.038a1.5,1.5,0,0,1-1.267-1.266h0l-.036-.264a.5.5,0,0,0-.493-.429h0a.5.5,0,0,0-.493.427l-.038.265a1.5,1.5,0,0,1-1.269,1.268l-.264.038a.5.5,0,0,0,0,.986l.263.038a1.5,1.5,0,0,1,1.269,1.269l.038.264a.5.5,0,0,0,.493.427h0a.5.5,0,0,0,.493-.429l.036-.262A1.5,1.5,0,0,1,17.95,9.419l.265-.038A.5.5,0,0,0,18.643,8.889Z']],
  AbTestingChemistryMonitor: ['ab-testing-chemistry-monitor', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0,2.5v7c0,.018,0,.035,0,.052A2.5,2.5,0,0,0,2.5,12H6.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3.625a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2H9.25A.25.25,0,0,1,9,13.25v-1A.25.25,0,0,1,9.25,12H14a2.5,2.5,0,0,0,2.5-2.448c0-.017,0-.034,0-.052v-7A2.5,2.5,0,0,0,14,0H2.5A2.5,2.5,0,0,0,0,2.5Zm14.5,0V8a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,8V2.5A.5.5,0,0,1,2.5,2H14A.5.5,0,0,1,14.5,2.5Z', 'M23.25,18.116V11.75A.25.25,0,0,0,23,11.5H20.5a.25.25,0,0,0-.25.25v6.386C20.25,20.815,23.25,20.857,23.25,18.116Z', 'M23.25,9h-3a.75.75,0,0,0,0,1.5h3a.75.75,0,0,0,0-1.5Z', 'M17.5,15.5a.75.75,0,0,0,0-1.5h-2a.75.75,0,0,0,0,1.5Z', 'M17.5,18.358V16.75a.25.25,0,0,0-.25-.25h-1.5a.25.25,0,0,0-.25.25v1.608a.507.507,0,0,1-.074.263l-2.861,4.633-.009.017A.5.5,0,0,0,13,24h7a.5.5,0,0,0,.444-.729l-.009-.017-2.86-4.633A.5.5,0,0,1,17.5,18.358Z']],
  AbTestingChemistryMonitor1: ['ab-testing-chemistry-monitor-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.95,11h-2.9a1.5,1.5,0,0,0-1.5,1.5v3.167a.253.253,0,0,1-.018.094l-2.362,5.873A1.643,1.643,0,0,0,14.642,24h7.713a1.644,1.644,0,0,0,1.476-2.366l-2.363-5.868a.248.248,0,0,1-.018-.093V12.5A1.5,1.5,0,0,0,19.95,11Zm.7,8.39a.249.249,0,0,1-.207.11h-3.9a.25.25,0,0,1-.232-.343l1.08-2.688.006-.013a1.507,1.507,0,0,0,.143-.641V13.25A.25.25,0,0,1,17.8,13h1.4a.25.25,0,0,1,.25.25v2.565a1.437,1.437,0,0,0,.117.581l.007.016,1.1,2.745A.248.248,0,0,1,20.653,19.39Z', 'M14,0H2.5A2.5,2.5,0,0,0,0,2.5v7c0,.018,0,.035,0,.052A2.5,2.5,0,0,0,2.5,12H6.75a.25.25,0,0,1,.25.25v1a.25.25,0,0,1-.25.25H3.625a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2H9.25A.25.25,0,0,1,9,13.25v-1A.25.25,0,0,1,9.25,12H14a2.5,2.5,0,0,0,2.5-2.448c0-.017,0-.034,0-.052v-7A2.5,2.5,0,0,0,14,0Zm.5,8a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,8V2.5A.5.5,0,0,1,2.5,2H14a.5.5,0,0,1,.5.5Z']],
  AbTestingSmartphones: ['ab-testing-smartphones', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.75,0h-7a2,2,0,0,0-2,2V16a2,2,0,0,0,2,2h5.5a1,1,0,0,0,1-1V13a1,1,0,0,0-1-1H4a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,4,2h6.5a.25.25,0,0,1,.25.25V4a1,1,0,0,0,2,0V2A2,2,0,0,0,10.75,0ZM7.25,14a1,1,0,1,1-1,1A1,1,0,0,1,7.25,14Z', 'M11.25,8V22a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2V8a2,2,0,0,0-2-2h-7A2,2,0,0,0,11.25,8Zm5.5,14a1,1,0,1,1,1-1A1,1,0,0,1,16.75,22ZM13.25,8.25A.25.25,0,0,1,13.5,8H20a.249.249,0,0,1,.25.25v9.5A.25.25,0,0,1,20,18H13.5a.25.25,0,0,1-.25-.25Z', 'M8.75,10.75A.75.75,0,0,0,9.5,10V5.5A2.25,2.25,0,0,0,5,5.5V10a.75.75,0,0,0,1.5,0V8a.25.25,0,0,1,.25-.25h1A.25.25,0,0,1,8,8v2A.75.75,0,0,0,8.75,10.75Zm-1-4.5h-1A.25.25,0,0,1,6.5,6V5.5A.75.75,0,0,1,8,5.5V6A.25.25,0,0,1,7.75,6.25Z', 'M15.25,16.75h1.5A2.253,2.253,0,0,0,19,14.5a2.219,2.219,0,0,0-.46-1.348.251.251,0,0,1,0-.3A2.219,2.219,0,0,0,19,11.5a2.253,2.253,0,0,0-2.25-2.25h-1.5a.75.75,0,0,0-.75.75v6A.75.75,0,0,0,15.25,16.75ZM16,11a.25.25,0,0,1,.25-.25h.5a.75.75,0,0,1,0,1.5h-.5A.25.25,0,0,1,16,12Zm0,3a.25.25,0,0,1,.25-.25h.5a.75.75,0,0,1,0,1.5h-.5A.25.25,0,0,1,16,15Z']],
  AbTestingBrowsers1: ['ab-testing-browsers-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18,4.5V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3v9.5a3,3,0,0,0,3,3H15a3,3,0,0,0,3-3Zm-8.5-3a1,1,0,1,1-1,1A1,1,0,0,1,9.5,1.5Zm-3,0a1,1,0,1,1-1,1A1,1,0,0,1,6.5,1.5Zm-3,0a1,1,0,1,1-1,1A1,1,0,0,1,3.5,1.5ZM16,12.5a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V6A1,1,0,0,1,3,5H15a1,1,0,0,1,1,1Z', 'M9,5.75A2.253,2.253,0,0,0,6.75,8v3.5a.75.75,0,0,0,1.5,0v-1a.25.25,0,0,1,.25-.25h1a.25.25,0,0,1,.25.25v1a.75.75,0,0,0,1.5,0V8A2.253,2.253,0,0,0,9,5.75ZM9.75,8.5a.25.25,0,0,1-.25.25h-1a.25.25,0,0,1-.25-.25V8a.75.75,0,0,1,1.5,0Z', 'M21,8.5h-.5a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H21a1,1,0,0,1,1,1V21a1,1,0,0,1-1,1H19a1,1,0,0,0,0,2h2a3,3,0,0,0,3-3V11.5A3,3,0,0,0,21,8.5Z', 'M11,22H9a1,1,0,0,1-1-1V17.5a1,1,0,0,0-2,0V21a3,3,0,0,0,3,3h2a1,1,0,0,0,0-2Z', 'M17.25,18.75a2,2,0,0,0-2-2H14a.75.75,0,0,0-.75.75v5a.75.75,0,0,0,.75.75h1.25a2,2,0,0,0,2-2,1.96,1.96,0,0,0-.347-1.109.25.25,0,0,1,0-.282A1.96,1.96,0,0,0,17.25,18.75Zm-2,3H15a.25.25,0,0,1-.25-.25V21a.25.25,0,0,1,.25-.25h.25a.5.5,0,0,1,0,1Zm0-2.5H15a.25.25,0,0,1-.25-.25v-.5a.25.25,0,0,1,.25-.25h.25a.5.5,0,0,1,0,1Z']],
  AbTestingBrowsers: ['ab-testing-browsers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,9H19.5a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h2.25a.25.25,0,0,1,.25.25V21a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V17.635a1,1,0,0,0-2,0V21a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V12A3,3,0,0,0,21,9Z', 'M15,5.25V10.5a1,1,0,0,0,2,0V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3v9a3,3,0,0,0,3,3h8a1,1,0,0,0,0-2H3a1,1,0,0,1-1-1V5.25A.25.25,0,0,1,2.25,5h12.5A.25.25,0,0,1,15,5.25ZM3.25,3.5A.75.75,0,1,1,4,2.75.749.749,0,0,1,3.25,3.5Zm2.5,0a.75.75,0,1,1,.75-.75A.749.749,0,0,1,5.75,3.5Zm2.5,0A.75.75,0,1,1,9,2.75.749.749,0,0,1,8.25,3.5Z', 'M10,12.25a.75.75,0,0,0,.75-.75V8a2.25,2.25,0,0,0-4.5,0v3.5a.75.75,0,0,0,1.5,0v-1A.25.25,0,0,1,8,10.25H9a.25.25,0,0,1,.25.25v1A.75.75,0,0,0,10,12.25ZM9,8.75H8a.25.25,0,0,1-.25-.25V8a.75.75,0,0,1,1.5,0v.5A.25.25,0,0,1,9,8.75Z', 'M18.25,15.5A2.253,2.253,0,0,0,16,13.25H14.5a.75.75,0,0,0-.75.75v6a.75.75,0,0,0,.75.75H16a2.253,2.253,0,0,0,2.25-2.25,2.219,2.219,0,0,0-.46-1.348.251.251,0,0,1,0-.3A2.219,2.219,0,0,0,18.25,15.5ZM16,19.25h-.5a.25.25,0,0,1-.25-.25V18a.25.25,0,0,1,.25-.25H16a.75.75,0,0,1,0,1.5Zm0-3h-.5a.25.25,0,0,1-.25-.25V15a.25.25,0,0,1,.25-.25H16a.75.75,0,0,1,0,1.5Z']]
};
exports["default"] = _default;